var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "nav-bar-container" }, [
        _c("div", { staticClass: "nav-bar" }, [
          _c("span", { staticClass: "summary-hello" }, [
            _vm._v(_vm._s(_vm.$t("hello"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "summary-name" }, [
            _vm._v(_vm._s(_vm.renderedName) + ","),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "summary-hello" }, [
            _vm._v(_vm._s(_vm.$t("welcome"))),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("label", { staticClass: "summary-hello emphasis" }, [
            _vm._v(_vm._s(_vm.$t("settings.title"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pages-settings-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "pages-settings-container",
            class: { largeForm: _vm.largeForm },
          },
          [
            _c(
              "div",
              { staticClass: "header row" },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab-container small-5 medium-5 large-3",
                    attrs: { id: "pages-settings-selector" },
                  },
                  [
                    _c("HKLSelect", {
                      attrs: {
                        value: _vm.settingsTabValue,
                        options: _vm.settingsTabHklOptions,
                        showSearch: false,
                        placeholder: "",
                      },
                      on: { change: _vm.onSettingsTabChange },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showUnlockBtn
                  ? _c("HKLButton", {
                      attrs: { color: "orange", action: "unlockExt" },
                      on: {
                        click: function () {
                          return _vm.openUnlockModal()
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tab-content-wrapper" },
              [_c("router-view", { staticClass: "tab-content" })],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("EngineerUnlockModal", { ref: "unlockModal" }),
      _vm._v(" "),
      _c("InviteUserModal", { ref: "unlockUserModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }